import useI18n from '@/hooks/useI18n';
import { FormDataForCreateCampaign } from '@/types/interfaces';
import React from 'react';
interface SelectAreaComponentProps {
  formData: FormDataForCreateCampaign;
}
const SelectAreaComponent: React.FC<SelectAreaComponentProps> = ({
  formData,
}) => {
  const { t } = useI18n();

  return (
    <div className="p-4 gap-[20px] flex flex-col">
      <div className="flex gap-4 items-center">
        <div className="w-[32px] h-[32px] bg-[#06B217] text-white rounded-full text-2xl text-center">
          4
        </div>
        <span className="text-[#172B4D] text-base font-semibold">
          {t('common.selectReachAreaForInStoreCampaign')}
        </span>
      </div>

      <div>
        <span className="text-[#9B919D] text-sm font-normal capitalize">
          {formData?.reachArea === 'global'
            ? t('common.eu+uk')
            : formData?.reachArea === 'eu'
              ? t('common.eu')
              : formData?.reachArea}
        </span>
        <div className="text-[#121111] text-lg font-medium">
          {formData?.selectedItems.map((item: string, index: number) => {
            return (
              <label key={item} className="gap-2 inline-flex">
                {/* {item}
                {index < formData.selectedItems.length - 1 ? ', ' : '.'} */}
                <div className="text-[18px] font-normal text-[#292828] flex items-center px-2 py-1 bg-gray-100 rounded-full mr-2 mt-2">
                  {item}
                </div>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectAreaComponent;
